var _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUgandaflag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M446.793,426.666C487.336,381.374,512,321.572,512,256s-24.665-125.375-65.208-170.667L256,66.783 L65.208,85.333C24.665,130.625,0,190.428,0,256s24.664,125.374,65.207,170.666L256,445.217L446.793,426.666z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.208,85.333h381.585C399.918,32.966,331.813,0,256,0S112.082,32.966,65.208,85.333z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M0,256l256,22.261L512,256c0-29.924-5.151-58.642-14.588-85.334H14.588 C5.151,197.358,0,226.076,0,256z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.588,341.333h482.826C506.849,314.641,512,285.924,512,256H0C0,285.924,5.151,314.641,14.588,341.333z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M446.793,426.666H65.207C112.081,479.034,180.186,512,256,512S399.919,479.034,446.793,426.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M341.426,256c0,47.183-38.243,85.426-85.426,85.426S170.574,303.183,170.574,256 s38.243-85.426,85.426-85.426S341.426,208.817,341.426,256z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.295,260.356L256,246.795c0,0,7.322-24.303,7.712-25.966c0.285-1.215,0.437-2.482,0.437-3.784 c0-4.611-1.869-8.785-4.891-11.805l7.87-7.87c-5.035-5.035-11.992-8.15-19.676-8.15c-7.684,0-14.641,3.114-19.676,8.15l7.87,7.87 c-3.022,3.021-4.89,7.195-4.89,11.805c0,1.686,0.255,3.311,0.72,4.846l-11.849,11.848h21.536c0,0-8.904,13.374-13.765,24.357 c-4.861,10.982,0.067,24.389,11.301,29.383l6.496,2.887L256,300.522v11.13l-11.13,11.13h22.261v-22.261l10.157-10.157h21.008 c0.101-0.209,0.207-0.413,0.303-0.627C303.59,278.504,298.53,265.348,287.295,260.356z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUgandaflag);
export default __webpack_public_path__ + "static/media/ugandaflag.c89415ffd5ffce32f32b95526c8bf6d7.svg";
export { ForwardRef as ReactComponent };